// @flow
export const AUCTION_STATE = {
  LIVE: 'live',
  PENDING: 'pending',
  CLOSED: 'closed',
  DRAFT: 'draft'
}

export const AUCTION_SHIPPING_OPTION = {
  NATIONAL: 'national',
  WORLDWIDE: 'worldwide',
  NONE: 'none'
}

export const AUCTION_DETAIL_MODAL = 'modal.auctionDetail'

export const AUCTION_DETAIL_MODAL_TYPE = {
  SCHEDULE: 'schedule',
  HOW_TO_ATTEND: 'howToAttend',
  QUESTIONS: 'auctionQuestions'
}



// WEBPACK FOOTER //
// ./src/services/auction/constants.js